module.exports = __webpack_public_path__ + "img/title_4.a53ceeb8.png";